import type { Phone } from "@tandemdiabetes/sugarmate-api-react-client"
import { useSavePhone } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { usePhones } from "./usePhones"
import type { PartialWithId } from "src/types"
import { noticeError } from "src/utils"

export function useUpdatePhone() {
  const savePhone = useSavePhone()
  const {
    mutate,
    data: phones,
  } = usePhones()

  return useMemo(
    () => savePhone && (async (phone: PartialWithId<Phone>) => {
      try {
        const response = await savePhone(phone)

        if (phones) {
          const responsePhone = response.data.phone

          const updatedList = phones.map((cachedPhone) => {
            if (cachedPhone.id === responsePhone.id) {
              return responsePhone
            }

            return cachedPhone
          })

          void mutate(updatedList)
        } else {
          void mutate()
        }

        return response
      } catch (e) {
        noticeError(
          e,
          "UpdatePhone",
          { ...phone },
        )

        throw e
      }
    }),
    [
      savePhone,
      phones,
      mutate,
    ],
  )
}
